import axios from 'axios';

import { BaseService } from 'core/services/base.abstract.service';
import { StatusCodes } from 'http-status-codes';

export class StatsService extends BaseService {
  constructor(env) {
    super(env);
  }

  createGuid() {
    return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, function () {
      var r = (Math.random() * 16) | 0;
      return r.toString(16);
    });
  }

  async PlayerInitialized(activitySessionId, resumeSession) {
    const key = 'activity-player-sessionid-' + activitySessionId;
    const checkExistingSessionId = sessionStorage.getItem(key);
    if (checkExistingSessionId) return;

    const sessionId = this.createGuid();
    sessionStorage.setItem(key, sessionId);
    let url = `${this.apiUrl}/api/activitysessions/${activitySessionId}/playersessions/${sessionId}`;
    return await axios
      .post(url, null, {
        headers: this.authorization,
        params: {
          e: resumeSession ? 'RESUMED' : 'INITIALIZED',
        },
      })
      .then(async (res) => {
        if (res.status !== StatusCodes.OK) throw new Error(res?.data?.error);
      })
      .catch((error) => {
        if (error.response?.data) throw new Error(error.response?.data);
      });
  }

  async PlayerExiting(activitySessionId) {
    const key = 'activity-player-sessionid-' + activitySessionId;
    const sessionId = sessionStorage.getItem(key);
    if (sessionId !== null) {
      sessionStorage.removeItem(key);
      let url = `${this.apiUrl}/api/activitysessions/${activitySessionId}/playersessions/${sessionId}`;

      // The token is passed in the querystring when using beacon API.
      // This is because the only way to add custom headers to a beacon
      // is to use a Blob as the 2nd parameter, but this triggers CORS
      // validation and the API is not configured to allow credentials,
      // and the beacon API provides no way to disable them.

      url += '?token=' + sessionStorage.getItem('token') + '&e=EXITED';
      navigator.sendBeacon(url);
    }
  }
}
